module.exports = __webpack_public_path__ + "fc860f225f76e8a9263b6d936dc60778.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/giant-bow-black.png
// module id = 2203
// module chunks = 0